import { Component, Input } from '@angular/core';
import { ICertificadoDeAnotaciones, IDatosBasicosSolicitud } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia.model';

@Component({
  selector: 'app-anotaciones-viewer',
  templateUrl: './anotaciones-viewer.component.html',
  styleUrls: ['./anotaciones-viewer.component.scss']
})
export class AnotacionesViewerComponent {
    @Input() content!: ICertificadoDeAnotaciones;
    @Input() datosBasicosSolicitud!: IDatosBasicosSolicitud;
    @Input() showHeader = true;

    public rut = '';
    public today = '';

    ngOnInit(): void {
        this.setToday();
        this.setRut();
    }

    setRut() {
        this.rut = this.datosBasicosSolicitud.Rut + '-' + this.datosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

}
